import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import menus from "../../src/user-config.json";
import { useCallback, useContext, useEffect } from "react";

import UserContext from "../components/Common/UserContext";
function AccessDenied() {
  const { isPresenter, setUserRole } = useContext(UserContext);
  const history = useHistory();
  const user = sessionStorage.getItem("userRole");

  //Once the user Logins successfully and tries to access route he is not allowed to visit he will be redirected to his
  //"Home Page" decided by the landing page in "menus.json{}" and if he hasn't login and still tries to access any route he will be sent to "Login.js" Page==============================================================================================//
  const home = isPresenter
    ? "/Presenter"
    : user
    ? menus[user.toLowerCase()]["menus"].filter(
        (item) => item?.landingPage === true
      )[0].route
    : "/";

  if (sessionStorage.getItem("accessDenied") == "false") {
    history.push(home);
    return null;
  }
  console.log(home);

  return (
    <div style={{ textAlign: "center", margin: "40px" }}>
      <h1 style={{ color: "red", margin: "40px" }}>Error:404</h1>
      <div style={{ fontSize: "20px" }}>You don't have access to this page</div>
      <div>
        Go back to{" "}
        <a
          href={home}
          onClick={() => {
            if (isPresenter) {
              setUserRole("Presenter");
              sessionStorage.setItem("userRole", "Presenter");
            }
            sessionStorage.setItem("accessDenied", false);
          }}
        >
          Home
        </a>{" "}
        Page
      </div>
    </div>
  );
}

export default AccessDenied;
